"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var text_1 = require("./text");
exports.CountVectorizer = text_1.CountVectorizer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2ZlYXR1cmVfZXh0cmFjdGlvbi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLCtCQUF5QztBQUVoQywwQkFGQSxzQkFBZSxDQUVBIn0=